export default "\n\n\n<div class=\"row\">\n  <div class=\"col-md-12 text-center\">\n    <img src=\"assets/images/no-product-found.png\" />\n  </div>\n</div>"